import { render } from "./BackAnketa.vue?vue&type=template&id=ac4b6c46"
import script from "./BackAnketa.vue?vue&type=script&lang=js"
export * from "./BackAnketa.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__